// extracted by mini-css-extract-plugin
export default {"video-player":"VideoProd_video-player__aDsGv"};